'use es6';

import { createSelector } from '@reduxjs/toolkit';
import { getCaptureVisitorEmailAddress } from 'conversations-internal-schema/message/operators/messageGetters';
import { getWelcomeMessage } from './getWelcomeMessage';
export const shouldCaptureVisitorEmailAddress = createSelector(getWelcomeMessage, getCaptureVisitorEmailAddress);